export enum LevelOfEducationGroup {
  Primary = 'primary',
  SHOOL_6_TO_4 = 'school_6_to_4',
  SHOOL_3 = 'school_3',
  Second = 'second',
  First = 'first',
  Terminal = 'terminal',
  Sup = 'sup',
}

export const getLevelOfEducationGroup = (levelOfEducationId: string) => {
  switch (levelOfEducationId) {
    // primaire
    case '5c92098687ab0734183f4e3e':
    case '5c920970859700b731ebeac9':
    case '5c92093bffed9c38145d15a8':
    case '5c92092712ccdf0366b28741':
    case '5c9208fe142c1e1f6abaef08':
      return LevelOfEducationGroup.Primary;
    // 6eme 4eme
    case '5832cd2e655165f324c1c0f7': // https://v1-kane.nomadeducation.fr/degrees/5832cd2e655165f324c1c0f7
    case '5ed91c83f4d7ff6a6cd2bba2': // https://v1-kane.nomadeducation.fr/degrees/5ed91c83f4d7ff6a6cd2bba2
    case '5798c55476922e7a0d2f1463': // https://v1-kane.nomadeducation.fr/levelofeducations/5798c55476922e7a0d2f1463
    case '5799cd5776922e7a0d2f4248': // https://v1-kane.nomadeducation.fr/levelofeducations/5799cd5776922e7a0d2f4248
    case '5799cd6176922e7a0d2f4249': // https://v1-kane.nomadeducation.fr/levelofeducations/5799cd6176922e7a0d2f4249
      return LevelOfEducationGroup.SHOOL_6_TO_4;
    // 3 eme
    case '5799ce1d76922e7a0d2f424a': // https://v1-kane.nomadeducation.fr/levelofeducations/5799ce1d76922e7a0d2f424a
    case '62165aee66bc9164e99f1d2d': // https://v1-kane.nomadeducation.fr/levelofeducations/62165aee66bc9164e99f1d2d
      return LevelOfEducationGroup.SHOOL_3;
    // seconde
    case '5ed917cc91fe723a6c2088d3': // https://v1-kane.nomadeducation.fr/levelofeducations/5ed917cc91fe723a6c2088d3
    case '60e42074878808218d0dce26': // https://v1-kane.nomadeducation.fr/levelofeducations/60e42074878808218d0dce26
    case '5798c4f31a19d2ec0d414735': // https://v1-kane.nomadeducation.fr/levelofeducations/5798c4f31a19d2ec0d414735
      return LevelOfEducationGroup.Second;
    // premiere
    case '5ed91807bbe3ee6d9d8499c4': // https://v1-kane.nomadeducation.fr/levelofeducations/5ed91807bbe3ee6d9d8499c4
    case '5798c4fc76922e7a0d2f145f': // https://v1-kane.nomadeducation.fr/levelofeducations/5798c4fc76922e7a0d2f145f
    case '60e4208ad76c842c636fac3d': // https://v1-kane.nomadeducation.fr/levelofeducations/60e4208ad76c842c636fac3d
      return LevelOfEducationGroup.First;
    // terminale
    case '60e4209fae03cf233e1bf004': // https://v1-kane.nomadeducation.fr/levelofeducations/60e4209fae03cf233e1bf004
    case '5ed91a1a8a378f396cc36940': // https://v1-kane.nomadeducation.fr/levelofeducations/5ed91a1a8a378f396cc36940
    case '5798c50d1a19d2ec0d414736': // https://v1-kane.nomadeducation.fr/levelofeducations/5798c50d1a19d2ec0d414736
      return LevelOfEducationGroup.Terminal;
    // sup
    case '5798c51a76922e7a0d2f1460':
    case '5798c5271a19d2ec0d414737':
    case '5798c53076922e7a0d2f1461':
    case '5a1e9424a2743c7275f55ea3':
    case '5798c54476922e7a0d2f1462':
    case '60094123959d077278d37a6d':
    case '5a96ac92a33ceae159d8b025':
    case '5a95848e70dd36bc0d56dccb':
    case '5a95849bd7421fc47cfd2844':
      return LevelOfEducationGroup.Sup;
    default:
      return LevelOfEducationGroup.SHOOL_6_TO_4;
  }
};
